import React, { createContext, useContext, useEffect, useState } from 'react';
import { isNonEmpty } from '../utils/arrayUtils';
import { useGetOrganizations } from '../networking/useOrganization';
const OrganizationContext = createContext({
    organization: null,
    isLoading: true,
    setOrganization: (org) => { },
});
const OrganizationProvider = ({ children, ...props }) => {
    const { statusCode, isLoading: isLoadingGet, data: dataGet, call: getOrganization } = useGetOrganizations();
    const [org, setOrg] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        getOrganization();
    }, []);
    useEffect(() => {
        if (!statusCode)
            return;
        if (dataGet && isNonEmpty(dataGet.items)) {
            setOrg(dataGet.items[0]);
        }
        setIsLoading(false);
    }, [isLoadingGet, dataGet]);
    return (React.createElement(OrganizationContext.Provider, { value: { organization: org, isLoading: isLoading, setOrganization: setOrg } }, children));
};
const useOrganization = () => {
    const context = useContext(OrganizationContext);
    if (!context) {
        throw new Error('useOrganization must be used within an OrganizationProvider');
    }
    return context;
};
export { OrganizationProvider, useOrganization };
